module.exports = __webpack_public_path__ + "static/media/grid-item-a11.4c7642e6.png";